import ClassFactory from 'sharedreact/utils/ClassFactory';

import CopyFileResult from 'sharedreact/data/CopyFileResult';
import DataBlock from 'sharedreact/data/DataBlock';
import FileInfo from 'sharedreact/data/FileInfo';
import FileInfoBarcode from 'sharedreact/data/FileInfoBarcode';
import FileInfoColorSpace from 'sharedreact/data/FileInfoColorSpace';
import FileInfoDFDimension from 'sharedreact/data/FileInfoDFDimension';
import FileInfoExternalReference from 'sharedreact/data/FileInfoExternalReference';
import FileInfoFont from 'sharedreact/data/FileInfoFont';
import FileInfoInk from 'sharedreact/data/FileInfoInk';
import FileInfoLayer from 'sharedreact/data/FileInfoLayer';
import FileInfoProcessingStep from 'sharedreact/data/FileInfoProcessingStep';
import FileInfoScreen from 'sharedreact/data/FileInfoScreen';
import FileInfoScreenAndDgc from 'sharedreact/data/FileInfoScreenAndDgc';
import FileInfoScreenSet from 'sharedreact/data/FileInfoScreenSet';
import FileInfoStructuralDesign from 'sharedreact/data/FileInfoStructuralDesign';
import FileInfoList from 'sharedreact/data/FileInfoList';
import Preview from 'sharedreact/data/PagePreview';
import Parameter from 'sharedreact/data/Parameter';
import ParameterRestriction from 'sharedreact/data/ParameterRestriction';
import Predicate from 'sharedreact/data/Predicate';
import PredicateRule from 'sharedreact/data/PredicateRule';
import PublicParameter from 'sharedreact/data/PublicParameter';
import PublicParameterGroup from 'sharedreact/data/PublicParameterGroup';
import Ticket from 'sharedreact/data/Ticket';
import TypedDate from 'sharedreact/data/TypedDate';
import TypedFloat from 'sharedreact/data/TypedFloat';
import TypedInteger from 'sharedreact/data/TypedInteger';
import TypeInfo from 'sharedreact/data/TypeInfo';
import UploadedFile from 'sharedreact/data/UploadedFile';
import UploadFileResult from 'sharedreact/data/UploadFileResult';
import Url from 'sharedreact/data/Url';
import User from 'sharedreact/data/User';
import SystemFileInfo from 'sharedreact/data/SystemFileInfo';
import InksForFile from 'sharedreact/data/InksForFile';
import AuditRecord from 'sharedreact/data/AuditRecord';

function _registerClasses (): void {
  ClassFactory.registerClassWithName('AuditRecord', AuditRecord);
  ClassFactory.registerClassWithName('CopyFileResult', CopyFileResult);
  ClassFactory.registerClassWithName('DataBlock', DataBlock);
  ClassFactory.registerClassWithName('FileInfo', FileInfo);
  ClassFactory.registerClassWithName('FileInfoBarcode', FileInfoBarcode);
  ClassFactory.registerClassWithName('FileInfoColorSpace', FileInfoColorSpace);
  ClassFactory.registerClassWithName('FileInfoDFDimension', FileInfoDFDimension);
  ClassFactory.registerClassWithName('FileInfoExternalReference', FileInfoExternalReference);
  ClassFactory.registerClassWithName('FileInfoFont', FileInfoFont);
  ClassFactory.registerClassWithName('FileInfoInk', FileInfoInk);
  ClassFactory.registerClassWithName('FileInfoLayer', FileInfoLayer);
  ClassFactory.registerClassWithName('FileInfoList', FileInfoList);
  ClassFactory.registerClassWithName('FileInfoProcessingStep', FileInfoProcessingStep);
  ClassFactory.registerClassWithName('FileInfoScreen', FileInfoScreen);
  ClassFactory.registerClassWithName('FileInfoScreenAndDgc', FileInfoScreenAndDgc);
  ClassFactory.registerClassWithName('FileInfoScreenSet', FileInfoScreenSet);
  ClassFactory.registerClassWithName('FileInfoStructuralDesign', FileInfoStructuralDesign);
  ClassFactory.registerClassWithName('InksForFile', InksForFile);
  ClassFactory.registerClassWithName('Parameter', Parameter);
  ClassFactory.registerClassWithName('ParameterRestriction', ParameterRestriction);
  ClassFactory.registerClassWithName('Predicate', Predicate);
  ClassFactory.registerClassWithName('PredicateRule', PredicateRule);
  ClassFactory.registerClassWithName('Preview', Preview);
  ClassFactory.registerClassWithName('PublicParameter', PublicParameter);
  ClassFactory.registerClassWithName('PublicParameterGroup', PublicParameterGroup);
  ClassFactory.registerClassWithName('SystemFileInfo', SystemFileInfo);
  ClassFactory.registerClassWithName('Ticket', Ticket);
  ClassFactory.registerClassWithName('TypedDate', TypedDate);
  ClassFactory.registerClassWithName('TypedFloat', TypedFloat);
  ClassFactory.registerClassWithName('TypedInteger', TypedInteger);
  ClassFactory.registerClassWithName('TypeInfo', TypeInfo);
  ClassFactory.registerClassWithName('uploadedFile', UploadedFile);
  ClassFactory.registerClassWithName('UploadFileResult', UploadFileResult);
  ClassFactory.registerClassWithName('Url', Url);
  ClassFactory.registerClassWithName('User', User);
}

class RegisterClasses {
  constructor () {
    _registerClasses();
  }
}

export default new RegisterClasses();
